export default __webpack_public_path__ + "static/media/Icon=Store Types.d57178b9.svg";